"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.hero.title': 'Activación de Cuenta',
    'activate.hero.description': '¡Bienvenido a IntHub! Estamos activando tu cuenta para que puedas comenzar.',
    'activate.hero.login_link_text': '¿Ya tienes una cuenta activa?',
    'activate.hero.login_link': 'Inicia sesión aquí',
};
